import { AvailabilityToHireProductEntity } from '../entities/availability-to-hire-product-entity';

export default class AvailabilityToHireProductState {
  items: Array<AvailabilityToHireProductEntity> = [];
}
